import React from "react";
import debounce from "lodash/debounce";
import PropTypes from "prop-types";

class ElementInViewport extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    nodeRef: PropTypes.object,
    partialVisibility: PropTypes.bool,
    onEnter: PropTypes.func,
    onExit: PropTypes.func,
    children: PropTypes.any,
  };

  static defaultProps = {
    nodeRef: null,
    partialVisibility: true,
    onEnter: () => {},
    onExit: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      seen: false,
    };

    props.nodeRef && this.setNodeRef(props.nodeRef);
  }

  setNodeRef = (ref) => (this.nodeRef = ref);

  componentDidMount() {
    this.attachListener();
  }

  componentWillUnmount() {
    this.removeListener();
  }

  attachListener() {
    document.addEventListener(`mousemove`, this.isComponentVisible, true);
    document.addEventListener(`visibilitychange`, this.isComponentVisible);
    window.addEventListener(`scroll`, this.isComponentVisible, true);
    window.addEventListener(`resize`, this.isComponentVisible, true);
  }

  removeListener() {
    this.isComponentVisible.cancel();
    document.removeEventListener(`mousemove`, this.isComponentVisible, true);
    document.removeEventListener(`visibilitychange`, this.isComponentVisible);
    window.removeEventListener(`scroll`, this.isComponentVisible, true);
    window.removeEventListener(`resize`, this.isComponentVisible, true);
  }

  isComponentVisible = debounce(() => {
    if (document.hidden) {
      this.setState({ seen: false }, () => this.props.onExit());
    } else {
      const { seen } = this.state;
      const html = document.documentElement;
      const boundingClientRect = this.nodeRef ? this.nodeRef.getBoundingClientRect() : null;
      const windowWidth = window.innerWidth || html.clientWidth;
      const windowHeight = window.innerHeight || html.clientHeight;

      const isVisible = boundingClientRect ? this.isVisible(boundingClientRect, windowWidth, windowHeight) : false;

      if (isVisible && !seen) {
        this.setState({ seen: true }, () => this.props.onEnter());
      } else if (seen && !isVisible) {
        this.setState({ seen: false }, () => this.props.onExit());
      }
    }
  }, 200);

  isVisible = ({ top, left, bottom, right, width, height }, windowWidth, windowHeight) => {
    const { partialVisibility } = this.props;

    if (top + right + bottom + left === 0) {
      return false;
    }

    return partialVisibility
      ? top + height >= 0 && left + width >= 0 && bottom - height <= windowHeight && right - width <= windowWidth
      : top >= 0 && left >= 0 && bottom <= windowHeight && right <= windowWidth;
  };

  render() {
    const { className, nodeRef, children } = this.props;

    return (
      <div
        className={className}
        ref={!nodeRef && this.setNodeRef}
      >
        {children}
      </div>
    );
  }
}

export default ElementInViewport;
